import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import ReservationsPage from '../../../subsreens/gcadmin/reservationpage/ReservationsPage';


const Reservations = () => {
    return(
       <AdminMasterLayout>
        <ReservationsPage></ReservationsPage>
       </AdminMasterLayout>
    )
}

export default Reservations;